module.exports = __webpack_public_path__ + "img/zzdh.38e14a18.png";